import { tafRequest } from 'amkit3-modules/utils/taf';
import GetVideoTranscodeUrlList from 'amkit3-modules/utils/taf/jce/GetVideoTranscodeUrlList';

export const getVideoTranscodeUrlList = (data) =>
  tafRequest({
    data: {
      ...data,
      cdnDispatchFlag: 1,
    },
    funcName: 'getVideoTranscodeUrlList',
    reqClass: GetVideoTranscodeUrlList.VideoTranscodeUrlReq,
    rspClass: GetVideoTranscodeUrlList.VideoTranscodeUrlRsp,
  });
